const FREE_VALUE_TYPES = ["q_numeric", "q_slider"];
const SCALE_TYPES = ["q_rating", "q_nps"];
const SCALE_MATRIX_TYPES = ["rating", "nps"];

export const COMPARISON_TYPES = ["gt", "gte", "lt", "lte"];

const BASE_TYPE_OPTIONS = [
  { label: "is", value: "is" },
  { label: "is not", value: "is_not" },
];
const COMPARISON_TYPE_OPTIONS = [
  { label: ">", value: "gt" },
  { label: "≥", value: "gte" },
  { label: "<", value: "lt" },
  { label: "≤", value: "lte" },
];
const BETWEEN_TYPE_OPTION = { label: "between", value: "between" };

export const isComparisonType = (type) => COMPARISON_TYPES.includes(type);

export function conditionValueInput(card) {
  if (!card) return null;
  if (FREE_VALUE_TYPES.includes(card.type)) return "free";
  if (SCALE_TYPES.includes(card.type)) return "scale";
  if (card.type === "q_matrix" && SCALE_MATRIX_TYPES.includes(card.specs?.matrix_type)) return "scale";
  return null;
}

export const isOrderedSource = (card) => conditionValueInput(card) !== null;

const TEXT_TYPES = ["q_open", "q_open_multiple", "q_zipcode", "q_city", "q_email", "q_audio", "q_image", "q_video"];
export const allowsTypedValues = (card) => !!card && (isOrderedSource(card) || TEXT_TYPES.includes(card.type));

export function conditionTypeOptions(card, currentType = null) {
  const options = isOrderedSource(card) ? [...BASE_TYPE_OPTIONS, ...COMPARISON_TYPE_OPTIONS] : [...BASE_TYPE_OPTIONS];
  if (conditionValueInput(card) === "free" || currentType === "between") options.push(BETWEEN_TYPE_OPTION);
  return options;
}

export const defaultConditionType = (card) => (conditionValueInput(card) === "free" ? "gte" : "is");

const isBlank = (value) => value == null || value === "";

export const hasConditionValue = (condition) => {
  if (condition?.type === "between") return !isBlank(condition.min) && !isBlank(condition.max);
  if (isComparisonType(condition?.type)) return !isBlank(condition.value);
  return (condition?.values?.length ?? 0) > 0;
};

const boundSegment = (value) => (isBlank(value) ? { kind: "empty", text: "…" } : { kind: "v", text: String(value) });

export const numericConditionSegments = (condition) => {
  if (condition.type === "between") {
    return [
      { kind: "plain", text: " between " },
      boundSegment(condition.min),
      { kind: "plain", text: " and " },
      boundSegment(condition.max),
    ];
  }
  if (!isComparisonType(condition.type)) return null;
  const symbol = COMPARISON_TYPE_OPTIONS.find(({ value }) => value === condition.type).label;
  return [{ kind: "plain", text: ` ${symbol} ` }, boundSegment(condition.value)];
};

export function resetConditionValues(condition) {
  condition.values = [];
  delete condition.value;
  delete condition.min;
  delete condition.max;
}
